import React, { useRef, useState } from 'react';
import { Label, Modal, ModalHeader, ModalBody, Form, FormGroup, FormFeedback, Button, Input, Table } from 'reactstrap';
import { FileUploader } from 'devextreme-react';
import styles from './aea-excel-modal.module.scss';
import { GridUtilities, Utilities, Enums } from '@utils';
import AEABatchGrid from '../aea-batch-grid/aea-batch-grid';
import { BatchGridColumnProps } from "@/components/ui/aea-batch-grid/aea-batch-grid";
export interface IAEAExcelModal {
    openModal: boolean;
    titleExcel: string;
    labelExcel1: string;
    labelExcel2: string;
    saveButton: string;
    cancelButton: string;
    gridDataExcel: any;
    originalData: any;
    RegionCountry?: any;
    formMasters?: any;

    onCancel(): void;
    onSaveDataExcel(value: any): void;
}

const AEAExcelModal = (props: IAEAExcelModal) => {
    const [gridInfo, setGridInfo] = useState(null);

    const onSubmitForm = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        event.stopPropagation();
        
        props.onSaveDataExcel(gridInfo.dataSource);
    }

    const onPaste = (e: any) => {
        generateTable(e.clipboardData.getData('text'));
        e.preventDefault();
        e.stopPropagation(); 
    }

    const getGridProps = (options: any) => {
        const gridData = GridUtilities.getGridData(options, options.id);
        const internalProps = {...GridUtilities.internalGridProps,...options.gridProps};
        internalProps.id = options.id;
        const readOnly = options.readOnly;
        return {
            gridProps:internalProps,
            columns: gridData.columns,
            dataSource: gridData.rows,
            readOnly: readOnly
        }
    }

    const validateItems = (column: BatchGridColumnProps, RegionCountry: any, event: any, valSel: any, columns: any) => {
        const newColumn: BatchGridColumnProps = { ...column };

        if (column.dataField === Enums.ListTypes.Country && !Utilities.isNullEmptyObject(RegionCountry)) {
            const region = props.formMasters.regions.find((x: any) => x.OCTAVIACodigo === RegionCountry[0].code);
            if (!Utilities.isNullObject(region)) {
                newColumn.items = props.formMasters.countries.filter((x: any) => x.OCTAVIAActivo === true).map((value: any) => {
                    return {
                        id: value.ID,
                        label: value.Title,
                        code: value.OCTAVIACodigo
                    }
                });
            }
            else {
                newColumn.items = [];
            }
        }

        if(column.dataField === "CodigoSubvencion" && props.formMasters){
            let indexFinancer = 0
            let indexFound: boolean = false
            columns.forEach((x: any) => { (x.dataField !== 'FinanciadorSap' && !indexFound) ? indexFinancer += 1 : indexFound = true})
            let financerId = columns[indexFinancer].items.find((x: any)=> x.label === event[indexFinancer])?.id
            if(financerId){
                let Financer = props.formMasters.sapFinancingEntities.filter((sapFinancer:any)=>financerId == sapFinancer.Id)
                let isAeA = Financer[0] ? Financer[0].PPresTipoFondoId === 1 : false;
                newColumn.items = isAeA ? props.formMasters.grantCodes.filter((_codeAeA:any)=> (_codeAeA.Title && _codeAeA.Title[0] == "A" && _codeAeA.OCTAVIAActivo) )      
                    :   props.formMasters.grantCodes.filter((_code:any)=> (_code.OCTAVIAActivo && _code.OCTAVIAFinanciadorSapId == financerId) )
                newColumn.items = Utilities.processDropDownData(newColumn.items, Enums.ListTypes.GrantCode);
            }else newColumn.items = [];
        }

        let finding = newColumn.items.filter((a:any) => a.label == valSel);
        return finding.length > 0 ? [finding[0].id] : []
    }

    const generateTable = (data: string) => {
        let tableRows: any[] = [];
        var rows = data.split("\n");
        var rowsCount = null;

        for(var y in rows) {
            var cells = rows[y].split("\t");
            var row = [];
            var empty = true;
            for(var x in cells) {
                var valCel = cells[x].trim();
                row.push(valCel);
                if (valCel != "" && valCel != "\r")
                    empty = false;
            }

            if (rowsCount == null || cells.length == rowsCount){
                rowsCount = cells.length;
                if (!empty) tableRows.push(row);
            }
        }

        let copyGrid = Utilities.copyObject(props.gridDataExcel) as any;

        let gridDefinition = copyGrid?.columns ? getGridProps(copyGrid) : copyGrid

        if (gridDefinition.gridProps){
            if (gridDefinition.gridProps.onToolbarPreparing) delete gridDefinition.gridProps.onToolbarPreparing;
            if (gridDefinition.gridProps.id) gridDefinition.gridProps.id = gridDefinition?.gridProps?.id + "_temp";
            else gridDefinition.gridProps.id = "excel_temp";
        }
        
        gridDefinition.readOnly = true;

        let auxColumns = [];
        let ppto = false;
        if (gridDefinition?.columns){
            auxColumns = gridDefinition?.columns
        } else {
            auxColumns = gridDefinition
            ppto = true
        }

        let dataSourceColumns: any[] = []
        auxColumns.forEach((a: any) => {
            let isVisible = a.visible || true
            let isReadOnly = a.readOnly || false
            if(isVisible && !isReadOnly || (a.dataField == "Pep") || (a.dataField == "CodigoProyectoFFCC")) {
                dataSourceColumns.push(a);
            }
        });
        gridDefinition.columns = dataSourceColumns
        let dataSource: any[] = [];

        tableRows.forEach((a: any, i: number) => {
            let newObj: any = {}
            newObj.Id = 0;
            
            a.forEach((b: any, j: number) => {
                if(dataSourceColumns[j]){
                    let valSel = b;
                    switch (dataSourceColumns[j].fieldType) {
                        case "number":
                        case "money":
                            valSel = valSel.split('$').join('');
                            valSel = valSel.split('€').join('');
                            if (valSel.indexOf('.') >= 0 && valSel.indexOf(',') >= 0){
                                if (valSel.indexOf('.') < valSel.indexOf(',')){
                                    valSel = valSel.split('.').join('');
                                    valSel = valSel.split(',').join('.');
                                } else 
                                    valSel = valSel.split(',').join('');
                            } else if (valSel.indexOf(',') >= 0){
                                valSel = valSel.split(',').join('.');
                            }

                            valSel = (isNaN(parseFloat(valSel)) ? null : parseFloat(valSel)) || null;
                            break;
                        case "checkbox":
                            valSel = (!Utilities.isNullEmptyObject(valSel) || valSel != false) ? true : false;
                            if (["EdicionPepLibre"].includes(dataSourceColumns[j].dataField))
                                valSel = false;
                            break;
                        case "select":
                            if(["Pais", "CodigoSubvencion"].includes(dataSourceColumns[j].dataField)) {
                                valSel = validateItems(dataSourceColumns[j], props.RegionCountry, a, valSel, dataSourceColumns)
                            }else{
                                let finding = dataSourceColumns[j].items.filter((a:any) => a.label == valSel);
                                valSel = finding.length > 0 ? [finding[0].id] : []
                            }
                            break;
                        default:
                            if (["Pep","CodigoProyectoFFCC"].includes(dataSourceColumns[j].dataField))
                                valSel = "";
                            break;
                    }

                    if (!((ppto && dataSourceColumns[j].fieldType == "select") && valSel.length == 0))
                        newObj[dataSourceColumns[j].dataField] = !Utilities.isNullEmptyObject(valSel) ? valSel : null;   

                    if(["Pep","CodigoProyectoFFCC"].includes(dataSourceColumns[j].dataField)){
                        newObj.PepManual = valSel;
                    }
                }
            });
            
            dataSource.push(newObj);
        });

        gridDefinition.dataSource = dataSource;
        setGridInfo(gridDefinition);
    }

    
    return (
        <>
            {props.openModal ?
                <>
                    <Modal isOpen={props.openModal} size="xl" >
                        <ModalHeader>{props.titleExcel}</ModalHeader>
                        <ModalBody>
                            <Form onSubmit={onSubmitForm}>
                                <FormGroup>
                                    <Label>{props.labelExcel1}</Label>
                                    <Input
                                        onPaste={onPaste}
                                        value={""}
                                        onChange={(e) => { e.preventDefault(); e.stopPropagation(); }}
                                        style={{resize: 'none'}}
                                        type="textarea" />
                                    <br />
                                    <br />
                                    <Label>{props.labelExcel2}</Label>
                                    <br />

                                    {gridInfo ? (
                                    <AEABatchGrid {...gridInfo} validateNums={true}></AEABatchGrid>
                                    ) : (
                                    <div></div>
                                    )}

                                </FormGroup>
                                <div className={styles.buttons}>
                                    <Button color="secondary" type="button" onClick={props.onCancel}>{props.cancelButton}</Button> 
                                    { gridInfo && 
                                        <Button color="primary" type="submit">{props.saveButton}</Button>
                                    }
                                </div>
                            </Form>
                        </ModalBody>
                    </Modal>
                </>
                : null
            }
        </>
    );
}

export default AEAExcelModal;